module.exports = __webpack_public_path__ + "img/2.f0378214.jpg";